export const isTrimmedEmpty = (value: string) => !value.trim();
